import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex a-i-center j-content-center" }
const _hoisted_2 = { class: "pagenation-select" }
const _hoisted_3 = {
  key: 0,
  class: "text-roboto-13 j-content-center a-i-center d-flex ml-3"
}
const _hoisted_4 = { class: "w-100 t-white150" }

import SelectComponent from "../select/SelectComponent.vue";
import { toRefs, ref, watch } from "vue";
import { PaginationType } from "./type";


export default /*#__PURE__*/_defineComponent({
  __name: 'paginationComponent',
  props: {
    total: {},
    total_info: { type: Boolean },
    pageSize: {},
    linkNext: {},
    linkPrev: {},
    link: {},
    callback: { type: Function }
  },
  setup(__props: any) {

const props = __props;


const data = toRefs(props);

const defaultValue = ref(1);

const next = () => {
  if (data.linkNext.value) {
    data.callback.value(data.linkNext.value || "");
    updateDefaultValue("increment");
  }
};

const prev = () => {
  if (data.linkPrev.value) {
    data.callback.value(data.linkPrev.value || "");
    updateDefaultValue();
  }
};

const updateMyValueSelect = (options: string) =>
  (defaultValue.value = Number(options));

watch(
  () => data.pageSize.value,
  () => {
    defaultValue.value = 1;
  }
);

// watch(
//   () => data.link.value,
//   () => {
//     if (data.linkNext.value)
//       defaultValue.value =
//         +((props.link?.match(/(page=([\d]{0,}))/) as RegExpMatchArray) ||
//           [])[2] - 1 || 1;
//     else
//       defaultValue.value =
//         +((props.linkPrev?.match(/(page=([\d]{0,}))/) as RegExpMatchArray) ||
//           [])[2] + 1 || 1;
//   }
// );

const updateDefaultValue = (options?: string) => {
  if (options === "increment") defaultValue.value++;
  else defaultValue.value--;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "btn-pagination pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (prev()))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectComponent, {
        myValueSelect: defaultValue.value.toString(),
        updateMyValueSelect: updateMyValueSelect,
        default: defaultValue.value.toString(),
        name: '',
        "key-or-value": false,
        options: 
          Array.from(
            { length: Math.ceil(_unref(data).total.value / +_unref(data).pageSize.value) },
            (v, i) =>
              _unref(data).link.value.replace(
                /(page=([\d]{0,}))/,
                `page=${(i + 1).toString()}`
              )
          )
        ,
        valueToIndex: true,
        update: _ctx.callback
      }, null, 8, ["myValueSelect", "default", "options", "update"])
    ]),
    _createElementVNode("div", {
      class: "btn-pagination right pointer",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (next()))
    }),
    (_unref(data)?.total_info?.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("Results")) + " " + _toDisplayString((
            Number(_unref(data).pageSize.value) * (defaultValue.value - 1) +
            1
          )?.toLocaleString()) + " - " + _toDisplayString(Number(_unref(data).pageSize.value) * defaultValue.value > _unref(data).total.value
            ? _unref(data).total.value?.toLocaleString()
            : (Number(_unref(data).pageSize.value) * defaultValue.value)?.toLocaleString()) + " of " + _toDisplayString(_unref(data).total.value?.toLocaleString()), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})